import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';

import Checklist from './checklist';
import ChecklistItemForm from './checklist_item_form';
import withDragDropContext from 'helpers/react_dnd/with_drag_drop_context';

import { showChecklistItemModal, hideChecklistItemModal } from '../actions/index';

export class ChecklistNavigator extends React.Component {

  static propTypes = {
    checklistItemModal: PropTypes.object,
    hideChecklistItemModal: PropTypes.func,
    showChecklistItemModal: PropTypes.func
  }

  showChecklistItemModal = (statusLabel, listingType) => {
    this.props.showChecklistItemModal(statusLabel, listingType);
  }

  render() {
    const sections = {
      sale: [
        { listingType: 'SaleListing', projectStatus: 'proposal', label: 'Proposal' },
        { listingType: 'SaleListing', projectStatus: 'on_market', label: 'Active' },
        { listingType: 'SaleListing', projectStatus: 'under_contract', label: 'Under Contract' },
        { listingType: 'SaleListing', projectStatus: 'closed', label: 'Closed' },
        { listingType: 'SaleListing', projectStatus: 'off_market', label: 'Inactive' }
      ],
      lease: [
        { listingType: 'LeaseListing', projectStatus: 'proposal', relation: 'Property', label: 'Proposal' },
        { listingType: 'LeaseListing', projectStatus: 'on_market', relation: 'Property', label: 'Active' },
        {
          listingType: 'LeaseSpaceListing',
          projectStatus: 'on_market',
          relation: 'individual Lease Spaces',
          label: 'Lease Space Active'
        },
        {
          listingType: 'LeaseSpaceListing',
          projectStatus: 'under_contract',
          relation: 'individual Lease Spaces',
          label: 'Lease Space Under Contract'
        },
        {
          listingType: 'LeaseSpaceListing',
          projectStatus: 'closed',
          relation: 'individual Lease Spaces',
          label: 'Lease Space Closed'
        },
        {
          listingType: 'LeaseSpaceListing',
          projectStatus: 'off_market',
          relation: 'individual Lease Spaces',
          label: 'Lease Space Inactive'
        }
      ],
      tenantRep: [
        { listingType: 'TenantRepListing', projectStatus: 'proposal', label: 'Proposal' },
        { listingType: 'TenantRepListing', projectStatus: 'on_market', label: 'Touring' },
        { listingType: 'TenantRepListing', projectStatus: 'under_contract', label: 'Under Contract' },
        { listingType: 'TenantRepListing', projectStatus: 'closed', label: 'Closed' },
        { listingType: 'TenantRepListing', projectStatus: 'off_market', label: 'Inactive' }
      ],
      buyerRep: [
        { listingType: 'BuyerRepListing', projectStatus: 'proposal', label: 'Proposal' },
        { listingType: 'BuyerRepListing', projectStatus: 'on_market', label: 'Touring' },
        { listingType: 'BuyerRepListing', projectStatus: 'under_contract', label: 'Under Contract' },
        { listingType: 'BuyerRepListing', projectStatus: 'closed', label: 'Closed' },
        { listingType: 'BuyerRepListing', projectStatus: 'off_market', label: 'Inactive' }
      ],
    };

    return (
      <div>
        <h2 onClick={this.props.showChecklistItemModal}>Checklist Settings</h2>
        <p>
          Add tasks that need to be completed within each project status.
          The checklist you define will be applied to all projects when changed to the corresponding status.
        </p>
        <Checklist
          projectTypeLabel="a Sale Listing Project"
          sections={sections.sale}
          showChecklistItemModal={this.showChecklistItemModal}
          title="Sale Listing Checklists"
        />
        <Checklist
          projectTypeLabel="a Lease Listing"
          sections={sections.lease}
          showChecklistItemModal={this.showChecklistItemModal}
          title="Lease Listing Checklists"
        />
        <Checklist
          projectTypeLabel="a Tenant Rep Assignment"
          sections={sections.tenantRep}
          showChecklistItemModal={this.showChecklistItemModal}
          title="Tenant Rep Checklists"
        />
        <Checklist
          projectTypeLabel="a Buyer Rep Assignment"
          sections={sections.buyerRep}
          showChecklistItemModal={this.showChecklistItemModal}
          title="Buyer Rep Checklists"
        />
        <Modal
          className="overflow-visible"
          enforceFocus={false}
          show={this.props.checklistItemModal.show}
          onHide={this.props.hideChecklistItemModal}
        >
          <Modal.Header closeButton>
            Add task
          </Modal.Header>
          <Modal.Body>
            <ChecklistItemForm
              item={this.props.checklistItemModal.item}
              listingType={this.props.checklistItemModal.listingType}
              projectStatus={this.props.checklistItemModal.projectStatus}
              onHide={this.props.hideChecklistItemModal}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps({ checklistItemModal }) {
  return { checklistItemModal };
}

export default connect(
  mapStateToProps,
  { showChecklistItemModal, hideChecklistItemModal }
)(withDragDropContext(ChecklistNavigator));
